import {
  StyleSheet,
  View,
  Image,
  TouchableOpacity,
  Platform,
} from "react-native";
import React, { useEffect, useState } from "react";
import * as ImagePicker from "expo-image-picker";
import { useAppDispatch, useAppSelector } from "../hooks/reduxHooks";
import { MaterialIcons } from "@expo/vector-icons";
import {
  ActivityIndicator,
  Button,
  Modal,
  Portal,
  Text,
  useTheme,
} from "react-native-paper";
import useApi from "../hooks/useAPI";
import { isic_get_card_microservice } from "../store/api";

import CachedImage from "./CachedImage";
import {
  createFormDataFileFromURI,
  getUserImageURI,
} from "../utils/ImageFunctions";
import { showMessage } from "react-native-flash-message";
import { setSubUser, setProfileImage } from "../store/slices/authSlice";

const defaultProfilePic =
  require("../../assets/images/home/default-avatar-profile-image.jpg") as Blob;

const PictureCard = () => {
  const { colors } = useTheme();

  const [confirmImageSrc, setConfirmImageSrc] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const api = useApi();
  const user = useAppSelector((s) => s.auth.subUser);
  const dispatch = useAppDispatch();
  const toggleModal = () => setConfirmationModal(!confirmationModal);

  const isDefaultImage: boolean =
    !user?.profile_image_id || user?.profile_image_id === "Base-profile-image";
  const [imageSrc, setImageSrc] = useState<any>(defaultProfilePic);

  useEffect(() => {
    const getImage = async () => {
      if (isDefaultImage) return;
      try {
        if (
          user!.profile_image_id.startsWith("file") ||
          user!.profile_image_id.startsWith("data")
        ) {
          setImageSrc({ uri: user?.profile_image_id });
          return;
        }
        const url = getUserImageURI(user!.profile_image_id);
        const res = await fetch(url, { mode: "cors" });
        const imageBlob = await res.blob();
        const fileReaderInstance = new FileReader();
        fileReaderInstance.readAsDataURL(imageBlob);
        fileReaderInstance.onload = () => {
          dispatch(setProfileImage(fileReaderInstance.result as string));
        };
      } catch (e) {
        console.log("E", e);
      }
    };
    getImage();
  }, [user?.profile_image_id]);
  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 4],
      quality: 1,
    });
    if (!result.cancelled) {
      setConfirmImageSrc(result.uri);
      setConfirmationModal(true);
    }
  };
  const handleConfirm = async () => {
    setLoading(true);
    try {
      // Save new image and save to the subuser state and finish loading
      const file = createFormDataFileFromURI(confirmImageSrc);
      let formData = new FormData();
      formData.append("photo", file as any, "photo.png");
      formData.append("aggregate_user", user!.id);
      setConfirmationModal(false);
      await api.userInfo.updateProfileImage(formData);
      setImageSrc({ uri: confirmImageSrc });
      dispatch(setProfileImage(confirmImageSrc));
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      showMessage({ type: "danger", message: "Erro durante o envio!" });
      setConfirmationModal(false);
    }
  };

  return (
    <View style={styles.root}>
      <TouchableOpacity onPress={pickImage}>
        {loading ? (
          <ActivityIndicator style={styles.image} />
        ) : isDefaultImage ? (
          <Image source={imageSrc} style={styles.image} />
        ) : (
          <CachedImage
            cacheKey={isDefaultImage ? "defaultImage" : user!.profile_image_id}
            source={imageSrc}
            style={styles.image}
          />
        )}
        <MaterialIcons
          name="edit"
          size={24}
          style={[styles.icon, { backgroundColor: colors.primary }]}
          color="#fff"
        />
      </TouchableOpacity>
      <Portal>
        <Modal
          visible={confirmationModal}
          onDismiss={toggleModal}
          contentContainerStyle={styles.modalContainer}
        >
          <Text style={styles.header}>
            Confirmar mudança de foto de perfil?
          </Text>
          <Image source={{ uri: confirmImageSrc }} style={styles.image} />
          <Text style={styles.subText}>
            Você poderá mudar a foto de perfil novamente quando quiser.
          </Text>
          <View style={styles.modalActions}>
            <Button mode="text" onPress={toggleModal}>
              Cancelar
            </Button>
            <Button
              mode="contained"
              labelStyle={{ color: "#fff" }}
              onPress={handleConfirm}
            >
              Salvar
            </Button>
          </View>
        </Modal>
      </Portal>
    </View>
  );
};

export default PictureCard;

const styles = StyleSheet.create({
  root: { alignItems: "center", justifyContent: "center" },
  image: {
    width: 88,
    height: 88,
    borderRadius: 44,
    alignSelf: "center",
  },
  icon: {
    position: "absolute",

    bottom: 0,
    right: 0,
    width: 31,
    height: 31,
    borderRadius: 9,
    textAlign: "center",
    lineHeight: 31,
  },
  modalContainer: {
    backgroundColor: "#fff",
    padding: 20,
    width: "90%",
    marginHorizontal: "5%",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
    elevation: 9,
    borderRadius: 10,
  },
  header: {
    fontWeight: "bold",
    fontSize: 20,
    color: "#000",
  },
  subText: {
    color: "rgba(0, 0, 0, 0.6)",
    fontSize: 16,
    marginVertical: 5,
  },
  modalActions: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
});
